export const DEFAULT_SPOTLIGHT_PADDING = 10;
export const DEFAULT_TOOLTIP_MARGIN = 12;
